// extracted by css-extract-rspack-plugin
export default {"content":"_50622843","text":"_85472f77","linkText":"_5f53c0d7"};